"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CsrfUtils = /** @class */ (function () {
    function CsrfUtils() {
    }
    CsrfUtils.csrfGetFormToken = function (form) {
        var $form = $(form);
        if ($form.find('input[name="_CSRF_INDEX"]').length === 0 ||
            $form.find('input[name="_CSRF_TOKEN"]').length === 0) {
            return null;
        }
        return {
            _CSRF_INDEX: $form.find('input[name="_CSRF_INDEX"]').val(),
            _CSRF_TOKEN: $form.find('input[name="_CSRF_TOKEN"]').val(),
        };
    };
    CsrfUtils.csrfUpdateFormToken = function (form, xhr) {
        if (xhr && xhr.responseJSON !== undefined && xhr.responseJSON._CSRF !== undefined) {
            var $form = $(form);
            $form.find('input[name="_CSRF_INDEX"]').val(xhr.responseJSON._CSRF._CSRF_INDEX);
            $form.find('input[name="_CSRF_TOKEN"]').val(xhr.responseJSON._CSRF._CSRF_TOKEN);
        }
        else if (xhr && xhr._CSRF !== undefined) {
            var $form = $(form);
            $form.find('input[name="_CSRF_INDEX"]').val(xhr._CSRF._CSRF_INDEX);
            $form.find('input[name="_CSRF_TOKEN"]').val(xhr._CSRF._CSRF_TOKEN);
        }
    };
    return CsrfUtils;
}());
exports.default = CsrfUtils;
